export class PresupuestoDetalle {
    idPresupuesto: number;
    idPresupuestoDetalle: number;
    idCotizacionDetalle: number;
    pUnitarioCotizacion: number;
    cantidad: number;
    descripcion: string;
    precioUnitario: number;
    utilidad: number;
    manoObra: number;
    pManoObra: number;
    montoAutorizado: number;
    manoObraAutorizado: number;
    idTipoPlanTrabajo: number;
    surteSeguro: boolean;
    autorizado: boolean;
    proveedor: string;
    manoObraPlan: number;
    costoPlan: number;
    tipoPlanTrabajo: string;
    tipo: string;
    total: number;
    index: number;
    comentarioPlan: string;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/presupuestoDetalle.ts